"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcInputBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_input_constants_1 = require("./bc-input-constants");
var bc_input_constants_2 = require("./bc-input-constants");
var bc_input_constants_3 = require("./bc-input-constants");
var bc_input_constants_4 = require("./bc-input-constants");
var bc_input_constants_5 = require("./bc-input-constants");
var bc_input_constants_6 = require("./bc-input-constants");
var bc_input_constants_7 = require("./bc-input-constants");
var bc_input_constants_8 = require("./bc-input-constants");
var bc_input_constants_9 = require("./bc-input-constants");
var bc_input_constants_10 = require("./bc-input-constants");
var bc_input_constants_11 = require("./bc-input-constants");
var bc_input_constants_12 = require("./bc-input-constants");
var bc_input_constants_13 = require("./bc-input-constants");
var bc_input_constants_14 = require("./bc-input-constants");
var bc_input_constants_15 = require("./bc-input-constants");
var bc_input_constants_16 = require("./bc-input-constants");
var bc_input_constants_17 = require("./bc-input-constants");
var bc_input_constants_18 = require("./bc-input-constants");
var bc_input_constants_19 = require("./bc-input-constants");
var bc_input_constants_20 = require("./bc-input-constants");
var bc_input_constants_21 = require("./bc-input-constants");
var bc_input_constants_22 = require("./bc-input-constants");
var bc_input_constants_23 = require("./bc-input-constants");
var bc_input_constants_24 = require("./bc-input-constants");
var bc_input_constants_25 = require("./bc-input-constants");
var bc_input_constants_26 = require("./bc-input-constants");
var bc_input_constants_27 = require("./bc-input-constants");
var bc_input_constants_28 = require("./bc-input-constants");
var bc_input_constants_29 = require("./bc-input-constants");
var bc_input_constants_30 = require("./bc-input-constants");
var bc_input_constants_31 = require("./bc-input-constants");
var bc_input_constants_32 = require("./bc-input-constants");
var bc_input_constants_33 = require("./bc-input-constants");
var bc_input_constants_34 = require("./bc-input-constants");
var bc_input_constants_35 = require("./bc-input-constants");
var bc_input_constants_36 = require("./bc-input-constants");
var bc_input_constants_37 = require("./bc-input-constants");
var bc_input_constants_38 = require("./bc-input-constants");
var bc_input_constants_39 = require("./bc-input-constants");
var bc_input_constants_40 = require("./bc-input-constants");
var bc_input_constants_41 = require("./bc-input-constants");
var bc_input_constants_42 = require("./bc-input-constants");
var helpers_1 = require("../../../common/helpers");
var bc_date_constants_1 = require("../../organisms/bc-calendar/bc-date-constants");
var BcInputBehavior = (function (_super) {
    __extends(BcInputBehavior, _super);
    function BcInputBehavior() {
        var _this = _super.call(this) || this;
        _this.imageFranchise = document.createElement(bc_input_constants_5.IMG_TAG);
        _this.isDecimals = true;
        _this.checkInput = function (value) { return value !== null && value !== undefined && value !== ''; };
        _this.addRemoveClass = function (bool, myself) {
            bool ? myself.classList.add(bc_input_constants_11.INPUT_ACTIVE_CLASS) : myself.classList.remove(bc_input_constants_11.INPUT_ACTIVE_CLASS);
        };
        _this.updateState = function (event) {
            if (_this.mySelf) {
                _this.addRemoveClass(_this.checkInput(_this.mySelf.value), _this.mySelf);
            }
        };
        _this.initInputfranchise = function (items) {
            _this.mySelf.insertAdjacentElement(common_constants_1.BcCommonConstants.BEFORE_BEGIN, _this.imageFranchise);
            _this.franchaiseInputConfig = items;
        };
        _this.valuesSearchMatchfranchise = function (data) {
            _this.franchaiseInputMatch = data;
        };
        return _this;
    }
    BcInputBehavior.prototype.setMyLastClass = function (myLastClass) {
        this.myLastClass = myLastClass;
    };
    BcInputBehavior.prototype.getMyLastClass = function () {
        return this.myLastClass;
    };
    BcInputBehavior.prototype.getIsDecimals = function (input) {
        return input.classList.value.includes(bc_input_constants_17.BC_INPUT_VALUE_INT_CLASS) ? false : true;
    };
    BcInputBehavior.prototype.setUpAll = function () {
        var imgElements = Array.from(document.querySelectorAll("[class^='".concat(bc_input_constants_10.INPUT_CLASS, "']")));
        var elements = [];
        for (var _i = 0, imgElements_1 = imgElements; _i < imgElements_1.length; _i++) {
            var element = imgElements_1[_i];
            var bc = new BcInputBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcInputBehavior.prototype._setUp = function () {
        this.addPaddingRightWhenIcon(this.mySelf);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, this.updateState);
        this.getInputs();
        this.setMyLastClass(this.mySelf.className);
        this.getMyLastClass();
        this.watchClassChanges(this.mySelf);
        this.createIconPassword(this.mySelf);
        this.inputValueListener(this.mySelf);
        this.createCreditCard(this.mySelf);
        this.getAttributesMsgError();
        this.listenerSetValueInput();
        if (this.mySelf.hasAttribute(bc_input_constants_1.ATTR_IS_INPUT_FRANCHISE)) {
            this.listenerFranchiseInput(this.mySelf);
            this.setWriteValue(this.mySelf.value);
            this.listenerSetValueFranchise();
        }
        this.validateMaxLength();
        this.validateMaxLengthWithoutSpan();
        this.changeDisabledState();
        this._listenForAttributeChanges();
    };
    BcInputBehavior.prototype.validateMaxLengthWithoutSpan = function () {
        if (this.mySelf.getAttribute('maxLength') && this.mySelf.getAttribute('clearCharacters') == 'true') {
            var input_1 = this.mySelf;
            var maxLength_1 = this.mySelf.getAttribute('maxLength');
            this.addListenerKeyUp(input_1, maxLength_1);
            input_1.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function () {
                input_1.value = input_1.value.substring(0, Number(maxLength_1));
            });
        }
    };
    BcInputBehavior.prototype.validateMaxLength = function () {
        if (this.mySelf.getAttribute('maxLength')) {
            var maxLength = this.mySelf.getAttribute('maxLength');
            var span = this.mySelf.parentElement.getElementsByClassName("".concat(bc_input_constants_7.INPUT_SPAN_INFO, " ").concat(bc_input_constants_8.INPUT_SPAN_INFO_COUNTER))[0];
            var input = this.mySelf;
            if (span) {
                span.textContent = "".concat(input.value.length, "/").concat(maxLength);
                this.addListenerKeyUp(input, maxLength, span);
            }
        }
    };
    BcInputBehavior.prototype.addListenerKeyUp = function (input, maxLength, spanInfo) {
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function () {
            if (input.value.length <= Number(maxLength)) {
                if (spanInfo) {
                    spanInfo.textContent = "".concat(input.value.length, "/").concat(maxLength);
                }
            }
            else {
                input.value = input.value.substring(0, input.value.length - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1);
            }
        });
    };
    BcInputBehavior.prototype.getInputs = function () {
        var inputs = Array.from(document.querySelectorAll("[class~='".concat(bc_input_constants_10.INPUT_CLASS, "'][class~='").concat(bc_input_constants_32.BC_INPUT_PASSWORD_CLASS, "']")));
        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
            var input = inputs_1[_i];
            (0, helpers_1.addFocusable)(input, { tabindex: '0' });
            input.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, "editar texto seguro");
        }
    };
    BcInputBehavior.prototype.inputValueListener = function (input) {
        var _this = this;
        if (input.classList.value.includes(bc_input_constants_16.BC_INPUT_VALUE_CLASS)) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function (e) {
                _this.formatInputValue(e, input);
                _this.updateState(e);
                _this.limitDecimals(input);
            });
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function () {
                _this.formatInputValueDecimal(input);
            });
        }
    };
    BcInputBehavior.prototype.limitDecimals = function (input) {
        input.value = input.value.replace(/,[,]+/g, ',');
        if (input.value.split(',').length > common_constants_1.COMMON_CONSTANTS_NUMBERS.N2) {
            var partes = input.value.split(',');
            input.value = partes.shift() + ',' + partes.join('');
        }
        var match = input.value.match(/^[^,]*,?[^,]{0,2}/);
        input.value = match ? match[0] : '';
    };
    BcInputBehavior.prototype.formatInputValueDecimal = function (input) {
        var num = input.value.replace(/\./g, '');
        if (num !== '' && num.length !== 0) {
            var numStr = num
                .toString()
                .replace(/[^\d,.]/g, '')
                .split(',');
            var intValue = numStr[0]
                .split('')
                .reverse()
                .join('')
                .replace(/(\d{3})(?=\d)/g, '$1.')
                .split('')
                .reverse()
                .join('');
            var decimalValue = numStr[1] || '';
            decimalValue = decimalValue.padEnd(common_constants_1.COMMON_CONSTANTS_NUMBERS.N2, '0');
            var maxDecimalValue = (intValue + ',' + decimalValue).split(',');
            if (maxDecimalValue.length > 1) {
                var decimals = maxDecimalValue[1].slice(0, common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
                if (this.getIsDecimals(input)) {
                    input.value = maxDecimalValue[0] + ',' + decimals;
                }
                else {
                    input.value = maxDecimalValue[0];
                }
            }
            else {
                input.value = intValue + ',' + decimalValue;
            }
        }
    };
    BcInputBehavior.prototype.formatInputValue = function (e, input) {
        if (e['data'] === ' ') {
            input.value = input.value.split(' ').join('');
        }
        var num = input.value.replace(/\./g, '');
        if (!isNaN(num)) {
            num = num.replace(/^0+/, '');
            num = num
                .toString()
                .split('')
                .reverse()
                .join('')
                .replace(/(?=\d*\.?)(\d{3})/g, '$1.');
            num = num.split('').reverse().join('').replace(/^[\.]/, '');
            input.value = num;
        }
        else {
            input.value = input.value.replace(/^0+/, '').replace(/[^\d\.,]*/g, '');
        }
    };
    BcInputBehavior.prototype.getAttributesMsgError = function () {
        this.firstMsgErrorAtr = this.mySelf.getAttribute(bc_input_constants_18.FIRST_MSG_ERROR_ATR) || bc_input_constants_19.MSG_ERROR_VALUE_DEFAULT;
        this.secondMsgErrorAtr = this.mySelf.getAttribute(bc_input_constants_20.SECOND_MSG_ERROR_ATR) || bc_input_constants_21.MSG_ERROR_VALUE_DATE_DEFAULT;
        this.thirdMsgError = this.mySelf.getAttribute(bc_input_constants_22.HIRD_MSG_ERROR_ATR) || bc_input_constants_23.MSG_ERROR_VALUE_DATA_DEFAULT;
    };
    BcInputBehavior.prototype.createCreditCard = function (input) {
        var _this = this;
        if (input.classList.value.includes(bc_input_constants_38.BC_INPUT_CREDIT_CARD)) {
            input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function (e) {
                _this.listenners();
                input.classList.add(bc_input_constants_11.INPUT_ACTIVE_CLASS);
                _this.updateState(e);
            });
        }
    };
    BcInputBehavior.prototype.listenners = function () {
        this.formatCreditCard(this.mySelf);
        this.validateDate(this.mySelf);
        this.validateDay(this.mySelf);
        this.validateQuantityNumbers(this.mySelf);
    };
    BcInputBehavior.prototype.formatCreditCard = function (input) {
        if (input['data'] === ' ') {
            input.value = input.value.split(' ').join('');
        }
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            var num = input.value.replace(/\D/g, '');
            num = num.length > 1 ? num.slice(0, bc_input_constants_26.NUMBER_2) + '/' + num.slice(bc_input_constants_26.NUMBER_2) : num;
            num = num.length > bc_input_constants_39.NUMBER_5 ? num.slice(0, bc_input_constants_39.NUMBER_5) : num;
            input.value = num;
        });
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === 'Backspace') {
                var value = input.value;
                if (input.selectionStart > 0 && value.charAt(input.selectionStart - 1) === '/') {
                    value = value.slice(0, input.selectionStart - 1) + value.slice(input.selectionStart);
                    input.value = value;
                    event.preventDefault();
                }
            }
        });
    };
    BcInputBehavior.prototype.validateDate = function (input) {
        var _this = this;
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            var _a;
            var span = (_a = input.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            if (input.value.length === bc_input_constants_39.NUMBER_5 && _this.validateDateNoLower(input.value)) {
                input.classList.add(bc_input_constants_12.INPUT_SUCCESS_CLASS);
                input.classList.remove(bc_input_constants_29.INPUT_ERROR_CLASS);
                if (span) {
                    span.textContent = 'Mes/Año';
                }
            }
            else if (input.value.length === bc_input_constants_39.NUMBER_5) {
                if (!_this.validateDateNoLower(input.value)) {
                    input.classList.remove(bc_input_constants_12.INPUT_SUCCESS_CLASS);
                    input.classList.add(bc_input_constants_29.INPUT_ERROR_CLASS);
                    if (span) {
                        span.textContent = _this.firstMsgErrorAtr;
                    }
                }
            }
            else {
                input.classList.remove(bc_input_constants_12.INPUT_SUCCESS_CLASS);
            }
        });
    };
    BcInputBehavior.prototype.validateDay = function (input) {
        var _this = this;
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function () {
            if (!_this.validateMonth(input.value)) {
                input.classList.remove(bc_input_constants_12.INPUT_SUCCESS_CLASS);
                input.classList.add(bc_input_constants_29.INPUT_ERROR_CLASS);
                var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
                span.textContent = _this.secondMsgErrorAtr;
            }
        });
    };
    BcInputBehavior.prototype.validateQuantityNumbers = function (input) {
        var _this = this;
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function () {
            if (input.value.length === bc_input_constants_39.NUMBER_5) {
                if (!_this.validateDate) {
                    input.value = input.value.slice(0, bc_input_constants_39.NUMBER_5);
                    input.classList.add(bc_input_constants_12.INPUT_SUCCESS_CLASS);
                    input.classList.remove(bc_input_constants_29.INPUT_ERROR_CLASS);
                    var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
                    span.textContent = 'Mes/Año';
                }
            }
            else {
                input.classList.remove(bc_input_constants_12.INPUT_SUCCESS_CLASS);
                input.classList.add(bc_input_constants_29.INPUT_ERROR_CLASS);
                var span = input.parentElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
                span.textContent = _this.thirdMsgError;
            }
        });
    };
    BcInputBehavior.prototype.validateMonth = function (input) {
        var _a = input.split('/').map(Number), mes = _a[0], _ = _a[1];
        if (mes > bc_input_constants_25.NUMBER_12) {
            return false;
        }
        return true;
    };
    BcInputBehavior.prototype.validateDateNoLower = function (input) {
        var fechaActual = new Date();
        var anioActual = fechaActual.getFullYear() % bc_input_constants_24.NUMBER_100;
        var mesActual = fechaActual.getMonth() + 1;
        var _a = input.split('/').map(Number), mesIngresado = _a[0], anioIngresado = _a[1];
        if (anioIngresado > anioActual || (anioIngresado === anioActual && mesIngresado >= mesActual)) {
            return true;
        }
    };
    BcInputBehavior.prototype.addPaddingRightWhenIcon = function (input) {
        if (this.checkSiblingElementEM(input)) {
            input.classList.add(bc_input_constants_28.INPUT_PADDING_RIGHT_WHEN_ICON);
        }
    };
    BcInputBehavior.prototype.checkSiblingElementEM = function (input) {
        if (input.nextElementSibling !== null) {
            return input.nextElementSibling.nodeName.toLowerCase() === bc_input_constants_13.EM_TAG;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.validateFlow = function (myLastClass, currentClass) {
        this.lastClassDontHaveClassess =
            !(myLastClass.includes(bc_input_constants_29.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS)) &&
                (currentClass.includes(bc_input_constants_29.INPUT_ERROR_CLASS) || currentClass.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS));
        this.removeTheIcon =
            (myLastClass.includes(bc_input_constants_29.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS)) &&
                !(currentClass.includes(bc_input_constants_29.INPUT_ERROR_CLASS) || currentClass.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS));
        this.changeToTheOtherClass =
            (myLastClass.includes(bc_input_constants_29.INPUT_ERROR_CLASS) || myLastClass.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS)) &&
                myLastClass !== currentClass;
    };
    BcInputBehavior.prototype.watchClassChanges = function (mySelf) {
        var _this = this;
        this.setMyLastClass(mySelf.className);
        var observer = new MutationObserver(function (event) {
            var _a;
            var currentClass = event[0].target.className;
            var myLastClass = _this.getMyLastClass();
            if (currentClass.includes(bc_input_constants_15.BC_INPUT_VALIDATION_CLASS)) {
                _this.validateFlow(myLastClass, currentClass);
                if (_this.lastClassDontHaveClassess) {
                    _this.bcInputValidation(mySelf);
                }
                else if (_this.removeTheIcon) {
                    _this.removeIconAndPadding(mySelf);
                    (_a = mySelf.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.remove(bc_input_constants_14.INVISIBLE_CLASS);
                    _this.setMyLastClass(mySelf.className);
                    _this.addRemoveClass(_this.checkInput(_this.mySelf.value), _this.mySelf);
                    _this.addPaddingRightWhenIcon(mySelf);
                }
                else if (_this.changeToTheOtherClass) {
                    _this.bcInputValidation(mySelf);
                }
            }
        });
        observer.observe(this.mySelf, {
            attributes: true,
            attributeFilter: ['class'],
            childList: false,
            characterData: false,
        });
    };
    BcInputBehavior.prototype.createIconPassword = function (input) {
        var emElement;
        if (input.classList.contains(bc_input_constants_32.BC_INPUT_PASSWORD_CLASS)) {
            emElement = this.createElementEM();
            input.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, emElement);
            this.classChangesIcon(emElement, input);
        }
    };
    BcInputBehavior.prototype.classChangesIcon = function (emElement, input) {
        if (input.value.trim() === '') {
            emElement.innerHTML = bc_input_constants_34.BC_ICON_NO_VIEW;
            input.setAttribute(bc_input_constants_35.TYPE_ATR, bc_input_constants_37.TYPE_PASSWORD);
            (0, helpers_1.addFocusable)(emElement, { tabindex: '0' });
            emElement.classList.add(bc_input_constants_30.INPUT_BUTTON_ICON_CLASS);
            emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'Mostrar contraseña, botón');
            this.addScreenReader(emElement);
            emElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                if (emElement.innerHTML === bc_input_constants_33.BC_ICON_VIEW) {
                    emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'Mostrar contraseña, botón');
                    input.setAttribute(bc_input_constants_35.TYPE_ATR, bc_input_constants_37.TYPE_PASSWORD);
                    emElement.innerHTML = bc_input_constants_34.BC_ICON_NO_VIEW;
                }
                else {
                    emElement.innerHTML = bc_input_constants_33.BC_ICON_VIEW;
                    emElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, 'ocultar contraseña, botón');
                    input.setAttribute(bc_input_constants_35.TYPE_ATR, bc_input_constants_36.TYPE_TEXT);
                }
            });
        }
    };
    BcInputBehavior.prototype.removeIconAndPadding = function (input) {
        if (this.checkSiblingElementEM(input)) {
            input.nextElementSibling.remove();
            input.style.paddingRight = '';
        }
    };
    BcInputBehavior.prototype.bcInputValidation = function (input) {
        var _a;
        var nextElementToInput = input.nextElementSibling;
        var emElement;
        if (this.checkNextElmentToInput(nextElementToInput)) {
            if (this.checkIfButtonIsErrorOSuccess(nextElementToInput.innerHTML)) {
                if (this.checkIfBottonAlreadyExist(nextElementToInput.innerHTML, input.className)) {
                    return;
                }
                else {
                    (_a = nextElementToInput.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(nextElementToInput);
                }
            }
            else {
                nextElementToInput.classList.add(bc_input_constants_14.INVISIBLE_CLASS);
            }
        }
        if (input.className.includes(bc_input_constants_12.INPUT_SUCCESS_CLASS)) {
            emElement = this.createElementEM();
            this.setSuccesIconography(emElement);
            input.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, emElement);
        }
        else if (input.className.includes(bc_input_constants_29.INPUT_ERROR_CLASS)) {
            emElement = this.createElementEM();
            this.setErrorIconography(emElement, input);
            input.insertAdjacentElement(common_constants_1.BcCommonConstants.AFTER_END, emElement);
        }
        input.style.paddingRight = '24px';
        this.setMyLastClass(input.className);
        this.addRemoveClass(this.checkInput(this.mySelf.value), this.mySelf);
    };
    BcInputBehavior.prototype.setSuccesIconography = function (emElement) {
        emElement.innerHTML = bc_input_constants_31.BC_INPUT_SUCCESSFUL_ICON;
    };
    BcInputBehavior.prototype.checkIfBottonAlreadyExist = function (nameButton, classess) {
        var tempClass;
        if (nameButton === bc_input_constants_31.BC_INPUT_SUCCESSFUL_ICON) {
            tempClass = bc_input_constants_12.INPUT_SUCCESS_CLASS;
        }
        else {
            tempClass = bc_input_constants_29.INPUT_ERROR_CLASS;
        }
        if (classess.includes(tempClass)) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.checkIfButtonIsErrorOSuccess = function (nameButton) {
        if (nameButton === bc_input_constants_31.BC_INPUT_SUCCESSFUL_ICON || nameButton === bc_input_constants_27.BC_INPUT_REMOVE_ICON) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.setErrorIconography = function (emElement, input) {
        var _this = this;
        emElement.innerHTML = bc_input_constants_27.BC_INPUT_REMOVE_ICON;
        (0, helpers_1.addFocusable)(emElement, { tabindex: '0' });
        emElement.classList.add(bc_input_constants_30.INPUT_BUTTON_ICON_CLASS);
        emElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (input.classList.contains(bc_input_constants_6.INPUT_CLASS_FRANCHISE)) {
                _this.hidenImageFranchise(false);
                _this.closeMessageErrorFranchise(input);
                var franchiseImage = input.previousElementSibling;
                franchiseImage.style.display = common_constants_1.BcCommonConstants.NONE;
            }
            input.className = input.className.replace(bc_input_constants_29.INPUT_ERROR_CLASS, '');
            input.className = input.className.replace(bc_input_constants_11.INPUT_ACTIVE_CLASS, '');
            input.value = '';
            input.focus();
        });
        this.addScreenReader(emElement);
    };
    BcInputBehavior.prototype.checkNextElmentToInput = function (nextElementToInput) {
        if (nextElementToInput.nodeName.toLowerCase() == common_constants_1.BcCommonConstants.EM_TAG) {
            return true;
        }
        else {
            return false;
        }
    };
    BcInputBehavior.prototype.createElementEM = function () {
        return document.createElement(bc_input_constants_13.EM_TAG);
    };
    BcInputBehavior.prototype.addScreenReader = function (element) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === ' ') {
                _this.focusNext(element);
            }
        });
    };
    BcInputBehavior.prototype.focusNext = function (element) {
        element.click();
    };
    BcInputBehavior.prototype.displayImage = function (objConfigFranchise) {
        var bodyStyles = window.getComputedStyle(document.body);
        var themeColor = bodyStyles.getPropertyValue('--bc-theme-color');
        if (themeColor == 'white') {
            this.imageFranchise.src = objConfigFranchise.logo.urlImgWhite;
        }
        else {
            this.imageFranchise.src = objConfigFranchise.logo.urlImgBlack;
        }
        this.imageFranchise.className = "".concat(bc_input_constants_3.ILUSTRATION_CLASS, " ").concat(common_constants_1.BcCommonConstants.ICONS_CLASS, " ").concat(bc_input_constants_4.IMG_M_CLASS);
        this.imageFranchise.style.display = common_constants_1.BcCommonConstants.BLOCK;
    };
    BcInputBehavior.prototype.verifyClassActive = function (input) {
        if (input.value) {
            input.classList.add(bc_date_constants_1.ACTIVE_CLASS_INPUT);
        }
        else {
            input.classList.remove(bc_date_constants_1.ACTIVE_CLASS_INPUT);
        }
    };
    BcInputBehavior.prototype.listenerFranchiseInput = function (input) {
        var _this = this;
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_INPUT, function (e) {
            var valueInput = e.target.value;
            var newValue = valueInput.replace(/[^0-9\s]/g, '');
            e.target.value = newValue;
            var resultFranchise = _this.searchObjFranchiseInput(e.target.value);
            if (resultFranchise) {
                e.currentTarget.value = resultFranchise;
            }
        });
        input.addEventListener(common_constants_1.BcCommonConstants.EVENT_FOCUSOUT, function (e) {
            _this.addMessageErrorFranchise(e.target);
        });
    };
    BcInputBehavior.prototype.listenerSetValueFranchise = function () {
        var that = this;
        this.observeElement(this.mySelf, 'value', function (oldValue, newValue) {
            if (oldValue != newValue) {
                that.setWriteValue(newValue);
            }
        });
    };
    BcInputBehavior.prototype.listenerSetValueInput = function () {
        var _this = this;
        this.observeElement(this.mySelf, 'value', function (oldValue, newValue) {
            if (oldValue != newValue) {
                var input = _this.mySelf;
                _this.verifyClassActive(input);
            }
        });
    };
    BcInputBehavior.prototype.observeElement = function (element, property, callback, delay) {
        if (delay === void 0) { delay = 0; }
        var elementPrototype = Object.getPrototypeOf(element);
        if (elementPrototype.hasOwnProperty(property)) {
            var descriptor_1 = Object.getOwnPropertyDescriptor(elementPrototype, property);
            Object.defineProperty(element, property, {
                get: function () {
                    return descriptor_1.get.apply(this, arguments);
                },
                set: function () {
                    var oldValue = this[property];
                    descriptor_1.set.apply(this, arguments);
                    var newValue = this[property];
                    if (typeof callback == 'function') {
                        setTimeout(callback.bind(this, oldValue, newValue), delay);
                    }
                    return newValue;
                },
            });
        }
    };
    BcInputBehavior.prototype.setWriteValue = function (value) {
        var currentInput = this.getMySelf();
        var resultFranchise = this.searchObjFranchiseInput(value);
        if (resultFranchise) {
            currentInput.value = resultFranchise;
        }
    };
    BcInputBehavior.prototype.addMessageErrorFranchise = function (input) {
        if (input.value.length > 0 && input.value.length < input.maxLength) {
            input.classList.add(bc_input_constants_29.INPUT_ERROR_CLASS);
            input.nextElementSibling.classList.add(bc_input_constants_2.ERROR_SPAN_CLASS);
        }
        else {
            input.nextElementSibling.classList.remove(bc_input_constants_2.ERROR_SPAN_CLASS);
            input.classList.remove(bc_input_constants_29.INPUT_ERROR_CLASS);
        }
    };
    BcInputBehavior.prototype.closeMessageErrorFranchise = function (input) {
        input.nextElementSibling.nextElementSibling.classList.remove(bc_input_constants_2.ERROR_SPAN_CLASS);
    };
    BcInputBehavior.prototype.searchObjFranchiseInput = function (inFirstNumberInput) {
        var isMatchSearch = null;
        var firstNumberInput = null;
        var valueInput = inFirstNumberInput;
        var positionGroupInput;
        valueInput = valueInput.replace(/[^\d]/g, '');
        if (this.franchaiseInputConfig) {
            for (var _i = 0, _a = this.franchaiseInputConfig; _i < _a.length; _i++) {
                var values = _a[_i];
                var _loop_1 = function (valuesInput) {
                    isMatchSearch = values.matchPattern.find(function (element) { return element == valuesInput; });
                    firstNumberInput = valueInput.toString().substring(0, values.pattern);
                    if (isMatchSearch && firstNumberInput == isMatchSearch) {
                        positionGroupInput = this_1.valueHasFoundFranchise(values, valueInput);
                        return { value: positionGroupInput };
                    }
                    else {
                        var notMatch = this_1.franchaiseInputConfig.find(function (element) { return !element.franchise; });
                        positionGroupInput = this_1.setPositions(valueInput, notMatch.spacingPositions);
                        this_1.imageFranchise.style.display = common_constants_1.BcCommonConstants.NONE;
                        this_1.hidenImageFranchise(false);
                    }
                };
                var this_1 = this;
                for (var _b = 0, _c = this.franchaiseInputMatch; _b < _c.length; _b++) {
                    var valuesInput = _c[_b];
                    var state_1 = _loop_1(valuesInput);
                    if (typeof state_1 === "object")
                        return state_1.value;
                }
            }
            return positionGroupInput;
        }
    };
    BcInputBehavior.prototype.valueHasFoundFranchise = function (objFranchise, currentValueInput) {
        this.hidenImageFranchise(true);
        this.displayImage(objFranchise);
        this.maxLengthFranchise(objFranchise);
        return this.setPositions(currentValueInput, objFranchise.spacingPositions);
    };
    BcInputBehavior.prototype.maxLengthFranchise = function (objConfigFranchise) {
        var currentInput = this.getMySelf();
        var arrToString = objConfigFranchise.spacingPositions.toString();
        var moreSpacingLength = arrToString.split(',').length - bc_input_constants_9.NUMBER_1;
        currentInput.maxLength = objConfigFranchise.maxLength + moreSpacingLength;
    };
    BcInputBehavior.prototype.hidenImageFranchise = function (boolDataIn) {
        var _a;
        var imgNotMatch = (_a = this.mySelf.previousElementSibling) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
        if (imgNotMatch) {
            imgNotMatch.style.display = boolDataIn ? common_constants_1.BcCommonConstants.NONE : common_constants_1.BcCommonConstants.BLOCK;
        }
    };
    BcInputBehavior.prototype.setPositions = function (inInput, arrSpacingPositions) {
        var valueInputFormatted = '';
        var lengthInput = inInput.length;
        var sizeIndex = 0;
        for (var i = 0; i < lengthInput; i++) {
            valueInputFormatted += inInput[i];
            if ((i + bc_input_constants_9.NUMBER_1) % arrSpacingPositions[sizeIndex] === 0 && i !== lengthInput - bc_input_constants_9.NUMBER_1) {
                valueInputFormatted += ' ';
                sizeIndex = (sizeIndex + bc_input_constants_9.NUMBER_1) % arrSpacingPositions.length;
            }
        }
        return valueInputFormatted;
    };
    BcInputBehavior.prototype._listenForAttributeChanges = function () {
        var _this = this;
        var attributesToObserve = [bc_input_constants_40.DATA_DISABLED];
        var config = { attributeFilter: attributesToObserve };
        var callback = function (mutationList, _) {
            for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
                var mutation = mutationList_1[_i];
                if (mutation.attributeName === bc_input_constants_40.DATA_DISABLED) {
                    _this.changeDisabledState();
                }
            }
        };
        var observer = new MutationObserver(callback);
        observer.observe(this.mySelf, config);
    };
    BcInputBehavior.prototype.changeDisabledState = function () {
        var disabled = this.mySelf.getAttribute(bc_input_constants_40.DATA_DISABLED);
        if (disabled === bc_input_constants_41.TRUE) {
            this.mySelf.setAttribute(common_constants_1.BcCommonConstants.DISABLED, '');
        }
        else if (disabled === bc_input_constants_42.FALSE) {
            this.mySelf.removeAttribute(common_constants_1.BcCommonConstants.DISABLED);
        }
    };
    return BcInputBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcInputBehavior = BcInputBehavior;
